// import { isFeatureEnabled } from 'owa-feature-flags';
// import { isEmailAddressDecoratedBrand } from 'owa-persona';

export default function shouldShowBrandDecoration(singleLastSenderSMTP: string): boolean {
    return false;

    // Temporarily disable brand decorations in the list view pending design review.
    // See work item 31530
    /*return (
        isFeatureEnabled('rp-brandDecorations') &&
        singleLastSenderSMTP &&
        isEmailAddressDecoratedBrand(singleLastSenderSMTP)
    );*/
}
